import type { ReadonlyDeep } from 'type-fest';

import { CodingStrategyEnum } from '@e-socna/data-layer';
import type { Id } from '@e-socna/data-layer';

import { missionForm2ApiMapper } from './mission.form2api.mapper';
import type { MissionForm_Mission } from '../fragments/mission.fragment';

// The mission as the form holds it, coded automatically: its code may not be chosen yet.
export const missionDraftForm2ApiMapper = (
  mission: ReadonlyDeep<MissionForm_Mission>,
  automaticStrategyId: Id,
) =>
  missionForm2ApiMapper({
    ...mission,
    codingConfig: {
      __typename: CodingStrategyEnum.CodingConfigAutomatic as const,
      kind: CodingStrategyEnum.CodingConfigAutomatic,
      strategyId: automaticStrategyId,
    },
  });
